module.exports = __webpack_public_path__ + "static/media/list_selected.68712b23.svg";